import { render, staticRenderFns } from "./toolDetails.vue?vue&type=template&id=65fca2ca&scoped=true"
import script from "./toolDetails.vue?vue&type=script&lang=js"
export * from "./toolDetails.vue?vue&type=script&lang=js"
import style0 from "./toolDetails.vue?vue&type=style&index=0&id=65fca2ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fca2ca",
  null
  
)

export default component.exports